import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from './views/Layout';
import Login from './views/Login';
import ResetPassword from './views/ResetPassword';
import ValidateEmail from './views/ValidateEmail'
import EmailValidado from './views/EmailValidado';
import EmailInvalido from './views/EmailInvalido';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Layout />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/validar-email" element={<ValidateEmail />} />
        <Route path="/email-validado" element={<EmailValidado />} />
        <Route path="/email-invalido" element={<EmailInvalido />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes;
